import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth, formatApiError } from "@/contexts/AuthContext";

export default function AdminLogin() {
  const nav = useNavigate();
  const { adminLogin } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await adminLogin(email.trim(), password);
      nav("/admin", { replace: true });
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="bg-[#050505] text-white pt-32 min-h-screen">
      <div className="px-6 md:px-12 lg:px-24 pb-24 max-w-md mx-auto">
        <div className="flex items-center gap-3 mb-4">
          <Lock className="w-5 h-5 text-[#E8A851]" />
          <p className="eyebrow">Admin console</p>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-medium tracking-tight mb-2">
          Sign in
        </h1>
        <p className="text-zinc-400 mb-12 text-sm">
          Authorized personnel only. Customers should use the{" "}
          <a href="/login" className="text-white underline">customer login</a>.
        </p>

        <form onSubmit={submit} className="border border-[#E8A851]/30 bg-[#E8A851]/[0.03] p-8 space-y-6">
          <div>
            <label className="eyebrow mb-2 block">Admin email</label>
            <input
              data-testid="admin-login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-white/20 focus:border-[#E8A851] text-white px-0 py-3 focus:outline-none"
            />
          </div>
          <div>
            <label className="eyebrow mb-2 block">Password</label>
            <input
              data-testid="admin-login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-white/20 focus:border-[#E8A851] text-white px-0 py-3 focus:outline-none"
            />
          </div>
          {err && <p data-testid="admin-login-error" className="text-sm text-red-400">{err}</p>}
          <button
            data-testid="admin-login-submit-button"
            type="submit"
            disabled={loading}
            className="btn-primary w-full justify-center disabled:opacity-50"
          >
            {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Signing in…</> : <>Enter admin console</>}
          </button>
        </form>
      </div>
    </div>
  );
}
